/** @jsx jsx */
import { jsx } from '@emotion/core'
import { Fragment, useEffect, useState } from 'react'
import * as _ from 'lodash'
import { observer } from 'mobx-react'
import { Badge, Tabs } from 'antd-mobile'
import { Models } from 'rmc-tabs/lib/Models'
import { isMobile, isSafari } from 'react-device-detect'
import { DetailMatchTrack, MatchTrack } from '@store/matchupStore'
import useRootStore from '@store/useRootStore'
import { GAME_TYPE } from '@game-type/game-market-types'
import { PAGE_TYPE } from '@interface/common'
import BottomLoading from '@components/BottomLoading'
import Chat from '@views/Popup/Chat'
import { BackTop } from 'antd'
import PageLoading from '@components/PageLoading'
import { useOnMount, useOnUnmount } from '@utils/reactExt'
import { EventStatusType, ProducerType } from '@game-type/betradar-type'
import LiveCount from '@views/Matchup/BetSlip/LiveCount'
import { isLsportsEnv, makeSimpleMatchInfoTrackByDetailTrack, matchupDetailScrollToTop } from '@utils/utils'
import { ChangeMatchIco } from '@shared/Icon/MatchupIcon'
import Navbar from '@views/Navbar'
import { SPORT_ID } from 'adv-protocol/src/GameCommon'
import { StatVisualizationWrapper } from '@views/Matchup/MatchUpDetail/TabContent/StatVisualizationWrapper'
import { Pick } from '@views/Matchup/MatchUpDetail/TabContent/Pick'
import { DetailMarket } from '@views/Matchup/MatchUpDetail/TabContent/DetailMarket'
import Login from '@views/Login'
import { MATCHUP_DETAIL_CONTENT_TAB_KEY } from '@constants/index'
import { LS_FIXTURE_STATUS } from '@v2/constants/common'
import { MatchupDetailSportTalk } from '@views/Matchup/MatchUpDetail/TabContent/MatchUpDetailSportTalk'
import { SimpleMatchInfo } from '@views/Matchup/MatchUpDetail/SimpleMatchInfo'
// icon
import LeagueEmblemImg from '@assets/images/icon/emblem_icon/league.png'
import { GoTopIco } from '@shared/Icon/ArrowIcon'
// css
import {
  BadgeStyle,
  ContentWrap,
  ModalLoading,
  Title,
  TitleWrap,
  TotalTabWrap,
  GoTopIcoStyle,
} from '@styles/base.style'
import { Button } from '@styles/button.style'
import DialogUtils from '@utils/dialog-utils'



const BETRADAR_CLASS = 'betradar'
const STATSCORE_CLASS = 'statscore'

let intervalObj

function MatchUpDetail() {
  const {
    matchupStore,
    globalStore,
    authStore,
    chattingStore,
    userPickStore,
  } = useRootStore()
  const [simpleMatchInfoClassName, setSimpleMatchInfoClassName] = useState('')
  const [detailTabWrapClassName, setDetailTabWrapClassName] = useState('')
  const [liveScoreIframeWrapClassName, setLiveScoreIframeWrapClassName] = useState('')
  const [isLoading, setLoading] = useState(false)

  const {
    detailTrack,
    pageType,
    currentGameKey,
    producerId,
    matchupDetailPackage,
    matchupDetailContentTabKey,
    currentSportId,
    majorUniqueID,
  } = matchupStore
  const { isChatEnabled } = chattingStore
  const {
    sportId = 178,
    categoryId,
    tournamentId,
    tournamentName = '리그명',
    tournamentEmblem,
  } = detailTrack || ({} as DetailMatchTrack)
  const { userPickMatchWayRatio } = userPickStore

  const track = detailTrack?.track ?? ({} as MatchTrack)
  const {
    statusCode,
    isVisible,
  } = track

  if (!_.isEmpty(track) && producerId === ProducerType.LIVEODDS && currentGameKey !== GAME_TYPE.LIVE) {
    matchupStore.setCategoryTab(0, GAME_TYPE.LIVE, true)
  }

  const contentTabs = []
  contentTabs.push({
    title: (
      <div className="tab-item">
        <span className="txt">BET</span>
      </div>
    ),
    name: 'BET',
    key: MATCHUP_DETAIL_CONTENT_TAB_KEY.BET,
  })
  contentTabs.push({
    title: (
      <div className="tab-item">
        <span className="txt">매치정보</span>
      </div>
    ),
    name: '매치정보',
    key: MATCHUP_DETAIL_CONTENT_TAB_KEY.MATCH,
  })
  contentTabs.push({
    title: (
      <div className="tab-item">
          <span className="txt">
            분석글
            <Badge
              text={matchupDetailPackage?.pickCount}
              overflowCount={99}
              css={BadgeStyle}
              className="pick-badge-tab"
            />
          </span>
      </div>
    ),
    name: '분석글',
    key: MATCHUP_DETAIL_CONTENT_TAB_KEY.PICK,
  })
  contentTabs.push({
    title: (
      <div className="tab-item">
        <span className="txt">
          스포츠톡
          <Badge
            text={matchupDetailPackage?.sportTalkCount}
            overflowCount={99}
            css={BadgeStyle}
            className="pick-badge-tab sport-talk"
          />
        </span>

      </div>
    ),
    name: '스포츠톡',
    key: MATCHUP_DETAIL_CONTENT_TAB_KEY.SPORT_TALK,
  })

  if (pageType === PAGE_TYPE.MATCHUP_RESULT || pageType === PAGE_TYPE.MATCHUP_RESULT_FILTER) {
    _.remove(contentTabs, { key: MATCHUP_DETAIL_CONTENT_TAB_KEY.BET })
  }


  const onClickChangeMatch = () => {
    if (!detailTrack) {
      return
    }

    DialogUtils.showChangeMatch({
      currentGameKey,
      imageSrc: tournamentEmblem || LeagueEmblemImg,
      tournamentName,
    })
  }

  useOnMount(async () => {
    window.addEventListener('scroll', scrollHandler, true)
    if (currentGameKey === GAME_TYPE.LIVE) {
      window.addEventListener('scroll', liveMatchScrollHandler, true)
    }
  })

  useOnUnmount(() => {
    window.removeEventListener('scroll', scrollHandler, true) /* 이벤트 삭제 */
    window.removeEventListener('scroll', liveMatchScrollHandler, true)
    matchupStore.clearDetailTrack()
  })

  useEffect((): void => {
    // 새로 고침 됬을 때 detailTrack 이 없는 경우를 확인해서
    // 새로 가져오기 전에 팝업 나오는 현상을 방지
    // 매치업 결과에서는 무시하도록 예외처리
    if (matchupStore.pageType !== PAGE_TYPE.MATCHUP_RESULT && pageType !== PAGE_TYPE.MATCHUP_RESULT_FILTER) {
      if (isLsportsEnv()) {
        if (
          statusCode === LS_FIXTURE_STATUS.FINISHED ||
          statusCode === LS_FIXTURE_STATUS.COVERAGE_LOST ||
          statusCode === LS_FIXTURE_STATUS.PENDING_FINISHED ||
          (detailTrack && !isVisible)
        ) {
          DialogUtils.showClosedMatchUpAlert(intervalObj)
        }
      } else {
        // eslint-disable-next-line no-lonely-if
        if (
          statusCode === EventStatusType.Closed ||
          statusCode === EventStatusType.Ended ||
          (detailTrack && !isVisible)
        ) {
          DialogUtils.showClosedMatchUpAlert(intervalObj)
        }
      }
    }
  }, [detailTrack, track])

  useEffect((): void => {
    matchupStore.fetchMatchupDetailPackage({
      matchId: track?.matchId,
      sportId: detailTrack?.sportId,
    }).catch(console.error)

    matchupDetailScrollToTop()
  }, [track.matchId])

  useEffect((): void => {
    if (isMobile) {
      return
    }

    if (pageType === PAGE_TYPE.MATCHUP_RESULT || pageType === PAGE_TYPE.MATCHUP_RESULT_FILTER) {
      matchupStore.setMatchupDetailContentTabKey(MATCHUP_DETAIL_CONTENT_TAB_KEY.SPORT_TALK)
      return
    }

    matchupStore.setMatchupDetailContentTabKey(MATCHUP_DETAIL_CONTENT_TAB_KEY.BET)
  }, [currentSportId, majorUniqueID, pageType])

  useEffect((): void => {
    const matchDetailWrap = document.getElementById('matchDetailWrap')
    if (!matchDetailWrap) return

    const isMatchupResult = pageType === PAGE_TYPE.MATCHUP_RESULT || pageType === PAGE_TYPE.MATCHUP_RESULT_FILTER
    const isInProgress = isLsportsEnv()
      ? statusCode === LS_FIXTURE_STATUS.IN_PROGRESS
      : statusCode === EventStatusType.Live
    const showVisualSupport = visualSupport && (currentGameKey === GAME_TYPE.LIVE || (isMatchupResult && isInProgress))
    const targetId = showVisualSupport ? 'betIframeWrap' : 'gamePreviewWrap'
    const targetWrap = document.getElementById(targetId)
    if (!targetWrap) return

    const targetHeight = targetWrap.clientHeight
    const isLive = (currentGameKey === GAME_TYPE.LIVE || (isMatchupResult && isInProgress)) && document.getElementById('betIframeWrap')

    const isShowSimpleInfo = isMobile && ['show-simple-info', 'live-score-tab'].includes(detailTabWrapClassName)
    const isPcScrolled = !isMobile && matchDetailWrap.scrollTop > targetHeight

    if (isShowSimpleInfo || isPcScrolled) {
      requestAnimationFrame(() => {
        requestAnimationFrame(() => {
          matchDetailWrap.scrollTo({
            top: targetWrap.clientHeight + (isMobile ? 11 : 1) + (isLive ? 26 : 0),
            behavior: 'instant',
          })
        })
      })
    } else {
      matchupDetailScrollToTop()
    }
  }, [matchupDetailContentTabKey])

  const liveMatchScrollHandler = () => {
    const matchDetailWrap = document.getElementById('matchDetailWrap')
    if (matchDetailWrap) {
      const scrollPosition = matchDetailWrap.scrollTop
      const liveDetailTab = document.getElementById('detailTabWrap')

      if (scrollPosition > 10 && liveDetailTab) {
        liveDetailTab.classList.add('scroll')
      }
    }
  }

  const onContentsFilterChange = (td: Models.TabData) => {
    const key = td.key as unknown as MATCHUP_DETAIL_CONTENT_TAB_KEY
    if (key === MATCHUP_DETAIL_CONTENT_TAB_KEY.PICK && !authStore.isSignedIn) {
      authStore.showLoginPopup(<Login/>)
      return
    }
    matchupStore.setMatchupDetailContentTabKey(key)
  }

  // visualization 설정
  let visualSupport = false
  switch (sportId) {
    case SPORT_ID.SOCCER:
    case SPORT_ID.BASKETBALL:
    case SPORT_ID.ICE_HOCKEY:
    case SPORT_ID.TABLE_TENNIS:
      visualSupport = true
      break
    case SPORT_ID.BASEBALL:
      if (categoryId === 16 && tournamentId === 109) {
        visualSupport = true
      }
      break
  }
  if (isLsportsEnv()) {
    visualSupport = true
  }

  // // TODO betradar와 statscore 전환에 대비한 코드
  let iframeWrapTypeClassName
  if (isLsportsEnv()) {
    iframeWrapTypeClassName = STATSCORE_CLASS
  } else {
    iframeWrapTypeClassName = BETRADAR_CLASS
  }

  const scrollHandler = () => {
    if (isMobile && globalStore.currentGeneralPopup) {
      const scrollPosition = document.getElementById('matchDetailWrap').scrollTop
      // const visualSection = document.getElementById('betIframeWrap')
      if (visualSupport && currentGameKey === GAME_TYPE.LIVE) {
        // 비주얼라이제이션 지원 O (라이브일 때만 지원함)
        const visualSection = document.getElementById('betIframeWrap')
        const visualH = visualSection?.scrollHeight || 0
        // iframe 띄움
        if (scrollPosition > visualH - 150 && scrollPosition > 150) {
          setLiveScoreIframeWrapClassName('show-live-score')
          setDetailTabWrapClassName('live-score-tab')
        } else {
          setLiveScoreIframeWrapClassName('')
          setDetailTabWrapClassName('')
        }
      } else {
        // 비주얼라이제이션 지원 X
        const previewSection = document.getElementById('gamePreviewWrap')
        const previewH = previewSection.scrollHeight

        if (scrollPosition > previewH - 35 && scrollPosition > 40) {
          setDetailTabWrapClassName('show-simple-info')
          setSimpleMatchInfoClassName('show-simple-info')
        } else {
          setDetailTabWrapClassName('')
          setSimpleMatchInfoClassName('')
        }
      }
    }
  }

  const getContentsTabIndexByTabKey = (key: MATCHUP_DETAIL_CONTENT_TAB_KEY) => {
    return _.findIndex(contentTabs, tab => tab.key === key)
  }

  const winRatio = userPickMatchWayRatio?.home ?? 0
  const drawRatio = userPickMatchWayRatio?.draw ?? 0
  const loseRatio = userPickMatchWayRatio?.away ?? 0
  const isGameInfoMatchChart = winRatio > 0 || drawRatio > 0 || loseRatio > 0

  const renderContents = () => {
    let footer
    if (isLoading) {
      footer = <PageLoading/>
    } else if (matchupDetailContentTabKey === MATCHUP_DETAIL_CONTENT_TAB_KEY.BET) {
      footer = <DetailMarket isLoading={isLoading} setLoading={setLoading}
                             detailTabWrapClassName={detailTabWrapClassName}
                             iframeWrapTypeClassName={iframeWrapTypeClassName}
                             visualSupport={visualSupport}
                             onChangeDetailTabWarpClassName={setDetailTabWrapClassName}
                             />
    } else if (matchupDetailContentTabKey === MATCHUP_DETAIL_CONTENT_TAB_KEY.MATCH) {
      footer = <StatVisualizationWrapper/>
    } else if (matchupDetailContentTabKey === MATCHUP_DETAIL_CONTENT_TAB_KEY.PICK) {
      footer = <Pick/>
    } else if (matchupDetailContentTabKey === MATCHUP_DETAIL_CONTENT_TAB_KEY.SPORT_TALK) {
      footer = <MatchupDetailSportTalk isGameInfoMatchChart={isGameInfoMatchChart}
                                       track={simpleMatchTrack}/>
    }
    return <div className="render-contents-wrap" css={{ textAlign: 'center' }}>{footer}</div>
  }

  let contentWarpStyle
  if (!isMobile) {
    contentWarpStyle = { overflow: 'auto', height: 'calc(100% - 70px)' }
  }

  let title = '상세 BET'
  if (pageType === PAGE_TYPE.MATCHUP_RESULT || pageType === PAGE_TYPE.MATCHUP_RESULT_FILTER) {
    title = '경기결과'
  }

  const simpleMatchTrack = makeSimpleMatchInfoTrackByDetailTrack(detailTrack)

  return (
    <Fragment>
      {!isMobile && (
        <TitleWrap className="title-wrap">
          {detailTrack && pageType !== PAGE_TYPE.MATCHUP_RESULT && pageType !== PAGE_TYPE.MATCHUP_RESULT_FILTER && (
            <Button className="change-match-btn" onClick={onClickChangeMatch}><ChangeMatchIco/></Button>)}
          <Title className="title">{title}</Title>
        </TitleWrap>
      )}

      <ContentWrap style={contentWarpStyle} id="matchDetailWrap"
                   className={isSafari ? 'content-wrap no-padding no-bg safari detail-bet' : 'content-wrap no-padding no-bg detail-bet'}>

        {matchupDetailContentTabKey === MATCHUP_DETAIL_CONTENT_TAB_KEY.SPORT_TALK && isMobile &&  (
          <BackTop
            key="matchDetailWrap:BackTop"
            target={() => {
              const targetElement = document.querySelector('.content-wrap')
              if (targetElement instanceof HTMLElement) {
                return targetElement
              }
              return window
            }}
          >
            <GoTopIcoStyle>
              <GoTopIco/>
            </GoTopIcoStyle>
          </BackTop>
        )}
        {isLoading ?
          <ModalLoading>
            <BottomLoading/>
          </ModalLoading>
          :
          // 상세BET 배당판 불러오는 도중 깜빡이는 현상 제어 (detail-bet-delay)
          <div className={isMobile ? 'detail-bet-delay' : 'detail-bet-delay pc'}>
            <SimpleMatchInfo track={simpleMatchTrack} outcomes={matchupDetailPackage?.outcomes}
                                wayRatio={matchupDetailPackage?.wayRatio} visualSupport={visualSupport}
                                gameKey={currentGameKey} pageType={pageType}
                                liveScoreIframeWrapClassName={liveScoreIframeWrapClassName}
                                simpleMatchInfoClassName={simpleMatchInfoClassName}
                                iframeWrapTypeClassName={iframeWrapTypeClassName}/>
            {detailTrack && (
              <TotalTabWrap
                underline
                className={`${detailTabWrapClassName} ${iframeWrapTypeClassName} matchup-detail content-tab`}
              >
                <Tabs
                  tabs={contentTabs}
                  page={getContentsTabIndexByTabKey(matchupDetailContentTabKey)}
                  onChange={onContentsFilterChange}
                  renderTabBar={tabProps => {
                    return (
                      <Tabs.DefaultTabBar {...tabProps}/>
                    )
                  }}
                />
              </TotalTabWrap>
            )}
            <div className="detail-bet-contents-wrap">
              {renderContents()}
            </div>
          </div>
        }
      </ContentWrap>

      {isMobile
        && isChatEnabled
        && authStore.isSignedIn
        && !authStore.isSpecificClubMember
        && <Chat chatBtnClass="matchup"/>}
      {isMobile && <LiveCount key="Matchup:LiveCount" matchupStore={matchupStore} globalStore={globalStore}/>}
      {isMobile && <Navbar key="Matchup:NavBar"/>}
    </Fragment>
  )
}

export default observer(MatchUpDetail)
